import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCollapsed: JSON.parse(localStorage.getItem("isCollapsed")) || false,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isCollapsed = !state.isCollapsed;
      localStorage.setItem("isCollapsed", JSON.stringify(state.isCollapsed));
    },
    setSidebarState: (state, action) => {
      state.isCollapsed = action.payload;
      localStorage.setItem("isCollapsed", JSON.stringify(state.isCollapsed));
    },
  },
});

export const { toggleSidebar, setSidebarState } = sidebarSlice.actions;
export default sidebarSlice.reducer;